<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="菜单"
      edit-title
      id-key="MenuId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="菜单名称" prop="MenuName">
          <el-input v-model="data.MenuName" placeholder="填写菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="Url">
          <el-input v-model="data.Url" placeholder="填写路径"></el-input>
        </el-form-item>
        <el-form-item label="上级" prop="Pid">
          <select-input
            placeholder="选择上级"
            :label="data.Pname"
            v-model="data.Pid"
            @click="openMenuDialog"
          />
        </el-form-item>
        <el-form-item label="排序" prop="Sort">
          <el-input-number :min="0" v-model="data.Sort"></el-input-number>
          <span class="t-tips">值越小排越前</span>
        </el-form-item>
        <div class="row-tb-head" style="margin-top: 10px;" v-if="data.MenuId">
          <span>菜单动作</span>
          <div style="float: right;margin-bottom:5px;">
            <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
          </div>
        </div>
        <el-row v-if="data.MenuId">
          <el-table ref="table" style="width: 100%;" :data="data.Funcs" border>
            <el-table-column prop="FuncCode" label="编码" width="130px">
              <template slot-scope="{row}">
                <el-input @input="onInput(row)" v-model="row.FuncCode"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="FuncName" label="名称" width="130px">
              <template slot-scope="{row}">
                <el-input @input="onInput(row)" v-model="row.FuncName"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Sort" label="序号">
              <template slot-scope="{row}">
                <el-input-number @input="onInput(row)" :min="0" @blur="checkInt(row)" v-model="row.Sort"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60px">
              <template slot-scope="{row,$index}">
                <el-button type="text" @click="del(row,$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </template>
    </common-dialog>
    <menu-dialog ref="menuDialog" title="选择上级菜单" @select="setParent"></menu-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";
import menuDialog from "./listDialog";
import api from "@/api/sy/menu";
import selectInput from "@/components/common/selectInput";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    menuDialog,
    selectInput,
  },
  data() {
    return {
      data: {
        MenuId: 0,
        MenuName: "",
        Url: "",
        Icon: null,
        Pid: 0,
        Pname: "",
        Lv: 1,
        Status: 1,
        Sort: 0,
        Idchain: "",
        NameChain: "",
        SnChain: "",
        Funcs: [],
      },
      DelFuncs: [],
      api,
      rules: {
        MenuName: [{ required: true, message: "菜单名称不能为空" }],
        Url: [{ required: true, message: "路径不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.data.Funcs = data.Funcs.map((x) => {
        return { ...x, T: null };
      });
      this.data.Status = 1;
    },
    openMenuDialog() {
      this.$refs.menuDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    setParent(parent) {
      if (this.data.MenuId == parent.MenuId) {
        this.$message.error("不可以选择自己为上级");
        return;
      }
      this.data.Pid = parent.MenuId;
      this.data.Pname = parent.MenuName;
      // console.log(this.data);
    },
    add() {
      var length = this.data.Funcs.length;
      var func = this.data.Funcs[length - 1];
      // console.log("func", func, length);

      this.data.Funcs.push({
        MenuFuncId: 0,
        MenuId: this.data.MenuId,
        FuncId: 0,
        FuncName: "",
        FuncCode: "",
        Sort: func ? func.Sort + 1 : 0,
        T: 0,
      });
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
    },
    checkInt(row) {
      if(!(row.Sort >= 0)) {
        row.Sort  = 0;
      } else if(row.Sort %1 != 0) {
        row.Sort = Math.floor(row.Sort);
      }
    },
    del(row, index) {
      if (row != 0) this.DelFuncs.push({ ...row, T: 2 });
      this.data.Funcs.splice(index, 1);
    },
    onBeforeSave() {
      var name = this.data.Funcs.some((x) => !x.FuncName);
      if (name) {
        this.$message.warning("菜单动作 - 名称不能为空");
        return false;
      }
      var code = this.data.Funcs.some((x) => !x.FuncCode);
      if (code) {
        this.$message.warning("菜单动作 - 编码不能为空");
        return false;
      }

      this.$refs.dialog.isLoading = true;
      var data = { ...this.data };
      data.Funcs = data.Funcs.filter((x) => x.T != null);
      this.DelFuncs.forEach((x) => {
        data.Funcs.push(x);
      });
      console.log("onBeforeSave", JSON.parse(JSON.stringify(data)));
      this.api.save(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });

      return false;
    },
    setSort(Sort) {
      this.data.Sort = Sort;
    },
  },
};
</script>